module.exports = __webpack_public_path__ + "static/media/related-cases4.c18614f8.jpg";